import { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Switch, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GROUPS_CONSTANTS from "../GroupsConstant";
import {
  columnHeaderRowSx,
  columnHeaderLabelSx,
  columnHeaderAccessCellSx,
  accessInfoIconButtonSx,
  accessInfoOutlinedIconSx,
  accessColumnTooltipSlotProps,
  scrollAreaSx,
  drawerLoadingBoxSx,
  getModuleRowSx,
  moduleLabelTypographySx,
} from "./GroupAccessDrawer.style";

const PAGE_ACCESS_COLUMN_HEADERS = GROUPS_CONSTANTS.groupAccessDrawer.COLUMN_HEADERS;
const Loading = lazy(() => import("common/Components/Loading"));

const PageAccessControlTabContent = ({
  loadingModules,
  moduleRows,
  switchesDisabled,
  onToggle,
}) => (
  <>
    <Box sx={columnHeaderRowSx}>
      <Typography sx={columnHeaderLabelSx}>
        {PAGE_ACCESS_COLUMN_HEADERS.MODULE_NAME}
      </Typography>
      <Box sx={columnHeaderAccessCellSx}>
        <Typography sx={columnHeaderLabelSx} component="span">
          {PAGE_ACCESS_COLUMN_HEADERS.ACCESS}
        </Typography>
        <Tooltip
          title={GROUPS_CONSTANTS.groupAccessDrawer.ACCESS_COLUMN_TOOLTIP}
          arrow
          placement="bottom"
          enterTouchDelay={0}
          leaveTouchDelay={4000}
          describeChild
          slotProps={accessColumnTooltipSlotProps}
        >
          <IconButton
            size="small"
            sx={accessInfoIconButtonSx}
            aria-label={GROUPS_CONSTANTS.groupAccessDrawer.ACCESS_COLUMN_TOOLTIP}
          >
            <InfoOutlinedIcon sx={accessInfoOutlinedIconSx} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>

    {loadingModules ? (
      <Box sx={drawerLoadingBoxSx}>
        <Suspense fallback={<div>{GROUPS_CONSTANTS.loading.FALLBACK}</div>}>
          <Loading />
        </Suspense>
      </Box>
    ) : (
      <Box sx={scrollAreaSx}>
        {moduleRows.map((row, index) => (
          <Box
            key={row.module}
            sx={getModuleRowSx(index, moduleRows.length)}
          >
            <Typography sx={moduleLabelTypographySx}>{row.label}</Typography>
            <Switch
              color="primary"
              checked={Boolean(row.enabled)}
              disabled={switchesDisabled}
              onChange={(e) => onToggle(row.module, e.target.checked)}
              inputProps={{ "aria-label": `${row.label} access` }}
            />
          </Box>
        ))}
      </Box>
    )}
  </>
);

PageAccessControlTabContent.propTypes = {
  loadingModules: PropTypes.bool.isRequired,
  moduleRows: PropTypes.arrayOf(
    PropTypes.shape({
      module: PropTypes.string.isRequired,
      enabled: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  switchesDisabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default PageAccessControlTabContent;
